// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"5831664d","82":"2bcd769d","122":"459f2e34","212":"7ff34198","213":"2d874c1d","454":"1738a517","526":"aa0e4d07","610":"840dd0e8","667":"86b3f0eb","782":"33a56de0","883":"cf26c873","912":"b295bc73","966":"319ad358","968":"fbf65c10"}[chunkId] + ".chunk.js";
};